<template>
  <div>
    <modal
      :ctrl="enableModalCtrl"
      :positiveLabel="{
        text: $t('OK'),
        color: 'green',
        icon: 'run',
        onclick: enable,
        disabled: !totp
      }"
      :negativeLabel="{ text: $t('CANCEL'), disabled: recoveryCodes !== null }"
      :modalClasses="['mini']"
    >
      <template v-slot:header>
        <div class="header">{{ $t('ENABLE_2FA_HEADER') }}</div>
      </template>

      <two-factor @totp="onTotp" :info="info" :recoveryCodes="recoveryCodes" />
    </modal>

    <p>{{ $t('2FA_PREFERENCE_DESCRIPTION') }}</p>
    <div class="ui toggle checkbox">
      <input id="2fa-enabled" type="checkbox" v-model="enabled" @click="toggle" />
      <label for="2fa-enabled">{{ $t('2FA_ENABLED') }}</label>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>

<script>
// @flow
import { Auth, User, Toast } from 'services'
import { Modal, ModalController } from 'ui'
import TwoFactor from '../TwoFactor'

export default {
  name: 'two-factor-authorization-preference',
  components: { Modal, TwoFactor },

  props: ['value', 'totpOnly'],

  data() {
    return {
      enableModalCtrl: new ModalController(),
      enabled: !_.isEmpty(this.value?.secret),
      info: {},
      totp: '',
      recoveryCodes: null
    }
  },

  computed: {},

  methods: {
    onTotp(code) {
      this.totp = code
    },
    toggle() {
      // reset some values
      this.info = {}
      this.totp = ''
      this.recoveryCodes = null

      if (this.enabled) {
        User.currentUser()
          .then(u => {
            // Get rid of the 2fa
            delete u.preferences['2fa']
            return User.updateUser(u.id, u)
          })
          .then(() => {
            this.enabled = false
          })
          .catch(err => {
            Toast.error(this.$i18n.t('ERR', { action: this.$i18n.t('REMOVING_2FA') }), {
              remove: 5000,
              text: err
            })
          })
      } else {
        Auth.twoFactor.init().then(info => {
          this.info = info
        })
        this.showModal()
          .catch(err => {
            this.enabled = false
          })
          .finally(() => {
            this.info = {}
            this.totp = ''
          })
      }
    },
    enable() {
      if (!_.isEmpty(this.recoveryCodes)) return true

      // Send TOTP to backend to verify
      Auth.twoFactor
        .enable(this.info.secret, this.totp)
        .then(r => {
          console.debug('enabled', r)
          this.recoveryCodes = r.recovery_codes
        })
        .catch(err => {
          console.error('2FA setup failed', err)
          this.enabled = false
          Toast.error(this.$i18n.t('ERR', { action: this.$i18n.t('AUTHENTICATE') }), {
            remove: 5000,
            text: this.$i18n.t('2FA_TOTP_VALIDATION_FAILED')
          })
        })
      return false
    },
    showModal() {
      return this.enableModalCtrl.show()
    }
  }
}
</script>
